import React from "react";
import Icon from "assets/icons";
import classNames from "classnames";
import { ImagePropTypes } from "./types";
import { getNameInitials } from "shared/utils";
import { DEFAULT_IMAGE_ALT } from "shared/utils/constants";
import useImageURLStatusCheck from "../../../hooks/useImageURLStatusCheck";

function Image(props: ImagePropTypes) {
  const { isLoading, isSuccess } = useImageURLStatusCheck({ imageLocation: props.src });

  return (
    <React.Fragment>
      {isLoading && props.showLoadingAnimation ? (
        <div className="shimmerEffect" />
      ) : isSuccess ? (
        <img
          src={props.src}
          style={props.style}
          width={props.width}
          height={props.height}
          onLoad={props.onLoad}
          onError={props.onError}
          onClick={props.onClick}
          alt={props.alt || DEFAULT_IMAGE_ALT}
          className={classNames("imageComponent--image", props.className)}
        />
      ) : props.entityFullName ? (
        <span className="imageComponent--initials">
          {getNameInitials(props.entityFullName, { bypassRestrictions: Boolean(props.bypassNameInitialRestrictions) })}
        </span>
      ) : props.fallbackRenderer ? (
        props.fallbackRenderer
      ) : (
        <Icon.NoImage className="imageComponent--icon" />
      )}
    </React.Fragment>
  );
}

export default Image;
